import React, { useState } from 'react'
import "../App.css"
import Searchsvg from "../Assets/imgs/search.svg"
import Settingssvg from "../Assets/imgs/settings.svg"

function Sidebar() {

    const [hover, setHover] = useState(false);
    const textdelay = 100; // in ms
    // TODO: sidebar element class

    return (
      <>
        <nav className="side-bar"
          onMouseEnter={() => {setTimeout(function() { setHover(true) }, textdelay)}}
          onMouseLeave={() => {setHover(false)}}
          // onMouseOver={() => { setHover(false) }}
          // onMouseOut={() => { setHover(false) }}
        ></nav>
        <ul
          className="sidebar-nav"
          onMouseEnter={() => {setTimeout(function() { setHover(true) }, textdelay)}}
          onMouseLeave={() => {setHover(false)}}
        >

          {/* TODO: Add a div */}
          <li
            className="side-item"
            onMouseEnter={() => {setTimeout(function() { setHover(true) }, textdelay)}}
            onMouseLeave={() => {setHover(false)}}
          >
            <a href="#" className="side-link">
              <img src={Settingssvg} />
              {hover && <span className="link-text">Settings</span>}
            </a>
          </li> 


        </ul>
      </>
    );
}

export default Sidebar
